import { AssetList } from "./AssetList";
import { DashboardHeader } from "./DashboardHeader";
import { EarningsMonitor } from "./EarningsMonitor";
import { EmergencyStopSell } from "./EmergencyStopSell";
import { MetricsGrid } from "./MetricsGrid";
import { OkxAssetList } from "./OkxAssetList";
import { OrderHistory } from "./OrderHistory";
import { OrderTicket } from "./OrderTicket";
import { PriceChart } from "./PriceChart";
import { StrategyControls } from "./StrategyControls";
import { TradingAnalysisMonitor } from "./TradingAnalysisMonitor";
import { Watchlist } from "./Watchlist";

export function DashboardLayout({
  dashboard,
  mode,
  setMode,
  selectedSymbol,
  setSelectedSymbol,
  selectedTicker,
  risk,
  setRisk,
  botBusy,
  toggleBot,
  saveRisk,
  credentialTools,
  orderTools,
  loadDashboard,
}) {
  return (
    <main className={mode === "live" ? "terminal-shell live" : "terminal-shell"} data-testid="trading-dashboard">
      <DashboardHeader connection={dashboard.connection} mode={mode} setMode={setMode} />
      <section className="grid-layout">
        <Watchlist tickers={dashboard.tickers} selectedSymbol={selectedSymbol} onSelect={setSelectedSymbol} />
        <section className="main-stack">
          <MetricsGrid portfolio={dashboard.portfolio} risk={dashboard.risk} />
          <PriceChart bot={dashboard.bot} performance={dashboard.performance} selectedSymbol={selectedSymbol} />
        </section>
        <StrategyControls
          bot={dashboard.bot}
          botBusy={botBusy}
          onToggleBot={toggleBot}
          risk={risk}
          setRisk={setRisk}
          onSaveRisk={saveRisk}
          okxCredentials={dashboard.okx_credentials}
          liveAutomation={dashboard.live_automation}
          liveConfig={credentialTools.liveConfig}
          setLiveConfig={credentialTools.setLiveConfig}
          onToggleLiveAutomation={credentialTools.toggleLiveAutomation}
        />
      </section>
      <section className="bottom-grid">
        <OrderTicket mode={mode} selectedTicker={selectedTicker} {...orderTools} />
        <AssetList assets={dashboard.portfolio.assets} />
        <OrderHistory trades={dashboard.recent_orders} />
      </section>
      <section className="single-grid">
        <EmergencyStopSell loadDashboard={loadDashboard} />
      </section>
      <section className="single-grid">
        <EarningsMonitor earnings={dashboard.earnings} />
      </section>
      <section className="single-grid">
        <TradingAnalysisMonitor analysis={dashboard.trading_analysis} />
      </section>
      <section className="single-grid">
        <OkxAssetList okxAssets={dashboard.okx_assets} />
      </section>
    </main>
  );
}